import React from 'react';
import { Dialog, Button } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PropTypes from 'prop-types';

import { T } from '../constants/tokens';

/**
 * The small "what is this" affordance beside a setting's label.
 *
 * Rendered as a bare button rather than a MUI IconButton: the v7 theme gives
 * IconButton a 36px circular border, which is right for the header's controls
 * and far too heavy sitting inline next to a label.
 */
export default class InfoButton extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleOpen = () => {
    this.setState({ open: true });
  }

  render() {
    return (
      <>
        <button
          type='button'
          aria-label={'About ' + (this.props.name ?? 'this setting')}
          onClick={this.handleOpen}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 20,
            height: 20,
            padding: 0,
            border: 0,
            background: 'transparent',
            color: T.mutedSoft,
            cursor: 'pointer',
            flex: 'none'
          }}
        >
          <InfoOutlinedIcon style={{ fontSize: 15 }} />
        </button>

        <Dialog open={this.state.open} onClose={this.handleClose} maxWidth='xs'>
          <div style={{ padding: 20, maxWidth: 380 }}>
            <div style={{ fontSize: 16, fontWeight: 600, lineHeight: '24px', color: T.ink, marginBottom: 8 }}>
              {this.props.name ? this.props.name : 'Help'}
            </div>
            <div style={{ fontSize: 14, lineHeight: '20px', color: T.body, textWrap: 'pretty' }}>
              {this.props.body ? this.props.body : ''}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
              <Button onClick={this.handleClose} variant='outlined'>Close</Button>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}

InfoButton.propTypes = {
  name: PropTypes.string,
  body: PropTypes.any
};
